import { create } from "zustand";
import type { CurrentUser } from "@/types";

interface AuthState {
  accessToken: string | null;
  user: CurrentUser | null;
  status: "loading" | "authenticated" | "guest";
  setSession: (accessToken: string, user: CurrentUser) => void;
  clear: () => void;
  setStatus: (status: AuthState["status"]) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  status: "loading",
  setSession: (accessToken, user) => set({ accessToken, user, status: "authenticated" }),
  clear: () => set({ accessToken: null, user: null, status: "guest" }),
  setStatus: (status) => set({ status }),
}));
